module.exports = __webpack_public_path__ + "img/emporte-piece-coeur-ex-voto-flamme.fea8561a.jpg";